import { combineReducers } from 'redux';
import cfg from '@/modules/application/reducers/cfg';
import auth from '@/modules/application/reducers/auth';
import dock from '@/modules/application/reducers/dock';
import types from '@/modules/application/reducers/types';
import statuses from '@/modules/application/reducers/statuses';
import affiliates from '@/modules/application/reducers/affiliates';
import downloading from '@/modules/application/reducers/downloading';
import leads_statuses_fetch from '@/modules/application/reducers/leads_statuses/fetch';

export default combineReducers({
    cfg,
    auth,
    dock,
    types,
    statuses,
    affiliates,
    downloading,
    leads_statuses_fetch,
});
